module.exports = __webpack_public_path__ + "static/visa-bitcoin-vityaz-8a90c33f5051bde8e207f0515df88d34.webp";